import { useMutation } from 'react-query'
import { showConfirmAlert, showError } from '../../../../../../../_metronic/helpers'
import { useListView } from '../../core/ListViewProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { deleteSelectedEmpresa } from '../../core/_requests'
import { TableBulkDangerButton, TableSelectionBar, useToast } from '../../../../../../components'

const EmpresasListGrouping = () => {
  const { selected, clearSelected } = useListView()
  const { refetch } = useQueryResponse()
  const { showToast } = useToast()
  const count = selected.length

  const deleteSelectedItems = useMutation(() => deleteSelectedEmpresa(selected), {
    onSuccess: () => {
      showToast({
        variant: 'success',
        title: count === 1 ? '1 instituição removida.' : `${count} instituições removidas.`,
      })
      clearSelected()
      refetch()
    },
    onError: showError,
  })

  const askRemove = async () => {
    const confirmed = await showConfirmAlert({
      title: count === 1 ? 'Remover 1 instituição?' : `Remover ${count} instituições?`,
      text: 'As instituições selecionadas e seus endereços serão excluídos. Essa ação não pode ser desfeita. Se quiser apenas suspender o uso, prefira inativar.',
      confirmButtonText: count === 1 ? 'Remover instituição' : `Remover ${count} instituições`,
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (confirmed) await deleteSelectedItems.mutateAsync()
  }

  return (
    <TableSelectionBar count={count} onClear={clearSelected}>
      <TableBulkDangerButton onClick={askRemove} disabled={deleteSelectedItems.isLoading}>
        {count === 1 ? 'Remover selecionada' : 'Remover selecionadas'}
      </TableBulkDangerButton>
    </TableSelectionBar>
  )
}

export { EmpresasListGrouping }
